import { RootState } from 'store';

export const selectors = {
  selectUser: (state: RootState) => state.user.user,
  selectNewEmail: (state: RootState) => state.user.newEmail,
};
